import React from 'react';

const CotizarContext = React.createContext({
    localidades: null,
    afinidades:null,
    afinidadesPic:null,
    coberturasInfo:null,
    autosModulos:null,
    dictModulosEmision: {},
    TR_ID_MODULOS: null,
    coveragesToFilter: null,
    isReady: false

});

export default CotizarContext;